<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="PN"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample">PART ONE</span></p>
<p class="PT"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="ePub-B">GHOSTS OF DAYS GONE BY</span></span></p>
<p class="EP-V">Thou shalt be killed if thee can’t find</p>
<p class="EP-V">the demon lurking in thou mind.</p>
<p class="EP-V">So off I ventured, to quench my thirst</p>
<p class="EP-V">of corpses piled with hearts-a-burst.</p>
<p class="EP-V">And on that quest what did I see?</p>
<p class="EP-V">The Wicked Path of Destiny.</p>
<div class="SPACE">
<p class="EPC"><span class="ePub-B">—Joseph Clifford</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?cfc5767e